import ApiHandler from '@/api/base'

class PowerBiApiHandler extends ApiHandler {
  async getLoginToken() {
    const { data } = await this.http.get('/powerbi/loginToken')
    return data
  }
}

export default PowerBiApiHandler
